import { SVGProps } from 'react';

const SvgInformations = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fill="#081930"
      fillRule="evenodd"
      d="M9 13a3 3 0 1 1 6 0v7a3 3 0 1 1-6 0v-7Zm3-1a1 1 0 0 0-1 1v7a1 1 0 1 0 2 0v-7a1 1 0 0 0-1-1ZM12 3a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM9 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0Z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgInformations;
